<div class="card plan-card shadow-sm">
  <div class="card-header plan-card__header">
    <div class="text-white p-3">
      <h2 class="plan-card__title m-0">{{ pagoPlan()?.name }}</h2>
      <p class="plan-card__subtitle m-0">
        <span>Moto: </span>
        <strong>{{ vehicleDescription() }}</strong>
      </p>
    </div>
  </div>

  <div class="card-body p-4">
    <h5 class="plan-card__section-title">Dueño:</h5>
    <div class="row owner-info">
      <div class="col-7">
        <p class="m-0">{{ ownerFullName() }}</p>
      </div>
      <div class="col-5 text-end">
        <p class="m-0">C.C. {{ ownerDocument() }}</p>
      </div>
    </div>
    <p class="owner-info">{{ cuidaCirculacion() }}</p>

    <hr class="my-3" />

    <div class="insured-value-box d-flex align-items-center p-3 mb-3">
      <img
        src="./assets/img/signoPeso.png"
        width="24"
        height="24"
        alt="Icono de peso"
        class="me-2"
      />
      <span class="fw-medium">
        Valor asegurado
        <strong class="ms-2">{{
          pagoPlan()?.sumInsured?.amount ?? 0 | customNumberFormat
        }}</strong>
      </span>
    </div>

    <hr class="my-3" />

    <h5 class="plan-card__section-title">Coberturas:</h5>
    <ul class="list-unstyled coverage-list">
      @for (cobertura of coveragesIncluded(); track cobertura) {
      <li class="d-flex align-items-center mb-2">
        <img
          src="./assets/img/iconoVineta.png"
          alt="Viñeta"
          class="me-2"
          width="24"
          height="24"
        />
        <span>{{ cobertura.name }}</span>
      </li>
      }
    </ul>

    <hr class="my-3" />

    <div class="sm-text-center">
      <p class="m-0 small">Tu póliza de seguro inicia el</p>
      <p class="fw-bold fs-5 policy-date m-0">
        {{ fecha() | date : "dd/MM/yyyy" }}
      </p>
    </div>
    @if (isSummary()) {
    <hr class="my-3" />

    <div class="payment-details">
      <div class="d-flex justify-content-between">
        <span class="fw-bold">Forma de pago</span>
        <span class="fw-bold">{{ paymentFrequencyText() }}</span>
      </div>

      @if (tipoPago() === 'Monthly') {
      <div class="d-flex justify-content-between mt-2">
        <span class="monthly-payment">Valor pago mensual</span>
        <span class="monthly-payment"
          >${{ valorMes() | customNumberFormat }}</span
        >
      </div>
      }
    </div>

    <hr class="my-3" />

    <div class="d-flex justify-content-between align-items-center">
      <span class="total-payment-label">Pago Total</span>
      <span class="total-payment-value"
        >${{ valorAPagar() | customNumberFormat }}</span
      >
    </div>
    }
  </div>

  @if (tipoPago() === 'Monthly' && isSummary()) {
  <div class="subscription-box align-items-center gap-3 p-3">
    <div class="subscription-tag d-sm-flex align-items-center px-2 py-1 my-2">
      <img
        src="./assets/img/wallet-icon.png"
        alt="Icono de billetera"
        class="d-sm-block subscription-img ms-2 ms-sm-0"
      />
      !Recomendado!
    </div>
    <div class="subscription-box d-flex align-items-center gap-3 p-2 p-sm-1">
      <div class="flex-grow-1">
        <p class="subscription-box__text m-0">
          ¡Activa tu suscripción y despreocúpate! Al elegir pagar con tarjeta
          débito o crédito,
          <strong>aceptas que cada mes se realice el débito automático </strong
          >del valor de tu seguro, para que siempre esté al día. Y si en algún
          momento lo necesitas, ¡puedes cancelarla fácil!
        </p>
      </div>
    </div>
  </div>
  }
</div>
@if (isSummary()) { @if (tipoPago() === 'Monthly') {
<div class="mt-4">
  <button
    class="btn btn-primary w-100 btn-lg rounded-pill"
    type="button"
    (click)="pagar('subscription')"
    [disabled]="disabledButton()"
  >
    Paga con tarjeta
  </button>
</div>
<div class="mt-4">
  <button
    class="btn btn-secondary w-100 btn-lg rounded-pill"
    type="button"
    (click)="pagar('payment')"
    [disabled]="disabledButton()"
  >
    Paga con PSE
  </button>
</div>
} @else {
<div class="mt-4">
  <button
    class="btn btn-primary w-100 btn-lg rounded-pill"
    type="button"
    (click)="pagar('payment')"
    [disabled]="disabledButton()"
  >
    Pagar
  </button>
</div>
} }
